import React from "react";

export default function Footer1() {
  return (
    <div>
      <img src="https://raw.githubusercontent.com/Trilokia/Trilokia/379277808c61ef204768a61bbc5d25bc7798ccf1/bottom_header.svg" />
    </div>
  );
}
